export class Carousels {
    constructor(aasScope, savKey) {
        this.aasScope = aasScope;
        this.savKey = savKey;
        this.cardsCount = 0;
        this.currentIndex = 0;
        this.initCarousel();
        this.bindEvents();
        this.updatePager();
    }
    initCarousel() {
        var _a;
        this.currentIndex = 0;
        const currentIndexSelector = this.getSelectorFromCardIndex(this.currentIndex);
        this.aasScope.querySelectorAll('.wrapper').forEach((element) => {
            element.classList.add(currentIndexSelector);
        });
        (_a = this.aasScope.querySelector('.aas-card')) === null || _a === void 0 ? void 0 : _a.classList.add(currentIndexSelector);
        this.cardsCount = this.aasScope.querySelectorAll('.aas-pager-container .pager-dot').length;
    }
    bindEvents() {
        this.bindNext();
        this.bindPrev();
        const aasContent = this.aasScope.querySelector('.aas-content');
        if (aasContent) {
            const hammertime = new Hammer.Manager(aasContent, {
                domEvents: true,
                recognizers: [
                    [Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL, threshold: 5, velocity: 0.1 }],
                ],
                drag_block_vertical: true
            });
            hammertime.on('swipe', (event) => {
                const gestureAngle = Math.abs(event.angle);
                if (gestureAngle >= 0 && gestureAngle <= 45) {
                    this.goPrev();
                }
                else if (gestureAngle >= 135 && gestureAngle <= 180) {
                    this.goNext();
                }
            });
        }
    }
    getSelectorFromCardIndex(index) {
        return `card-${index}`;
    }
    bindNext() {
        var _a;
        (_a = this.aasScope.querySelector('.pager-arrow-right')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.goNext();
        });
    }
    goNext() {
        if (this.currentIndex + 1 < this.cardsCount) {
            this.updateIndexSelector(this.currentIndex + 1);
        }
    }
    bindPrev() {
        var _a;
        (_a = this.aasScope.querySelector('.pager-arrow-left')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.goPrev();
        });
    }
    goPrev() {
        if (this.currentIndex - 1 >= 0) {
            this.updateIndexSelector(this.currentIndex - 1);
        }
    }
    updateIndexSelector(newIndex) {
        var _a;
        if (newIndex === this.currentIndex)
            return;
        const currentIndexSelector = this.getSelectorFromCardIndex(this.currentIndex);
        const newIndexSelector = this.getSelectorFromCardIndex(newIndex);
        this.aasScope.querySelectorAll('.wrapper').forEach((element) => {
            element.classList.remove(currentIndexSelector);
            element.classList.add(newIndexSelector);
        });
        (_a = this.aasScope.querySelector('.aas-card')) === null || _a === void 0 ? void 0 : _a.classList.replace(currentIndexSelector, newIndexSelector);
        this.currentIndex = newIndex;
        this.updatePager();
    }
    updatePager() {
        this.aasScope.querySelectorAll('.pager-dot-wrapper').forEach((element) => {
            element.querySelectorAll('.pager-dot').forEach((dot, index) => {
                dot.classList.toggle('current-dot', index === this.currentIndex);
            });
        });
        const prevButton = this.aasScope.querySelector('.pager-arrow-left');
        const nextButton = this.aasScope.querySelector('.pager-arrow-right');
        prevButton === null || prevButton === void 0 ? void 0 : prevButton.classList.toggle('hidden', this.currentIndex === 0);
        nextButton === null || nextButton === void 0 ? void 0 : nextButton.classList.toggle('hidden', this.currentIndex === this.cardsCount - 1);
    }
}
